module.exports = __webpack_public_path__ + "img/arrow_background_downward.16902ae.png";